import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/Census/admitted`;

/**
 * Obtiene el listado de pacientes con ingreso hospitalario actualmente activo
 * (sin discharge date).
 *
 * El scope por rol lo aplica el backend (Admin ve todos los locations,
 * otros roles solo su location primario).
 *
 * @param {Object} [filters]
 * @param {string} [filters.cipId]          - CIP específico.
 * @param {number} [filters.locationId]     - Center (dentro del scope permitido).
 * @param {string} [filters.searchName]     - LIKE sobre nombre completo.
 * @param {string} [filters.dateOfBirth]    - DOB exacto (YYYY-MM-DD).
 * @param {number} [filters.minLace]        - LACE+ mínimo.
 * @param {number} [filters.minAdmitDays]   - Días hospitalizado ≥ (útil para "prolongadas").
 * @param {string} [filters.dateFrom]       - Admit date ≥ (YYYY-MM-DD).
 * @param {string} [filters.dateTo]         - Admit date ≤ (YYYY-MM-DD).
 *
 * Ejemplo de llamada:
 * GET /api/Census/admitted?minAdmitDays=14
 *
 * Respuesta exitosa (200):
 * [
 *   {
 *     "admittedEventId": 3,
 *     "cipId": "86250340755",
 *     "fullName": "CHIMENTI, DANA",
 *     "dateOfBirth": "1981-03-02T00:00:00",
 *     "gender": "F",
 *     "phoneNumber": "(786) 459-4061",
 *     "mobileNumber": "(786) 459-4061",
 *     "memberEmail": "DCHIMENTI11@GMAIL.COM",
 *     "admitDate": "2026-02-22T00:00:00",
 *     "dischargeDate": null,
 *     "facilityName": "FLHIE - WEST PALM HOSPITAL",
 *     "placeOfService": "Inpatient Hospital",
 *     "diagnoses": "F32.A",
 *     "laceScore": 20,
 *     "behavioralHealth": false,
 *     "attendingPhysicianName": "LaFata,Maygen",
 *     "attendingPhysicianSpec": null,
 *     "facilityPhone": null,
 *     "facilityAddress": null,
 *     "facilityCity": null,
 *     "facilityState": null,
 *     "lastSeen": "2026-04-23T00:00:00",
 *     "admitDays": 60,
 *     "locationId": 5,
 *     "medicalCenter": "Lake Worth",
 *     "locationAddress": "3155 LAKE WORTH RD, Palm Springs, FL - 33461-6917, Palm Beach"
 *   }
 * ]
 *
 * `dischargeDate` siempre viene null en este endpoint por definición.
 * `admitDays` ya viene calculado por el backend.
 *
 * Posibles errores:
 * 401 Sin token o token inválido.
 * 500 Excepción en el SP o pipeline (el repo retorna lista vacía para no romper el front).
 */
export const getAdmittedPatients = async (filters = {}) => {
  try {
    const params = buildParams(filters);
    const response = await axios.get(API_URL, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admitted patients:", error);
    throw error;
  }
};

const buildParams = (filters) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    params[key] = value;
  });
  return params;
};
